import React from 'react'
import { useLeafletContext } from '@react-leaflet/core'
import L from 'leaflet'
import '@elfalem/leaflet-curve'
import { generateMidpointLatLng } from './mapUtils'
import { CurvePathOptions } from './mapTypes'

type Props = {
  startPoint: [number, number]
  endPoint: [number, number]
  options: CurvePathOptions
}

const Curve: React.FC<Props> = ({startPoint, endPoint, options}) => {
  const context = useLeafletContext()
  const curveRef = React.useRef<L.Curve>(null!)
  React.useEffect(() => {
    const midlatlng = generateMidpointLatLng(startPoint, endPoint)
    curveRef.current = new L.Curve(['M', startPoint, 'Q', midlatlng, endPoint], {
      fill: false,
      opacity: 1,
      weight: 3,
      ...options,
    })

    const container = context.layerContainer || context.map
    container.addLayer(curveRef.current)

    return () => container.removeLayer(curveRef.current)
  }, [context, startPoint, endPoint, options])

  return null
}

export default React.memo(Curve)
